export enum InvestmentStatus {
  REQUESTED_BY_CUSTOMER = 'REQUESTED_BY_CUSTOMER',
  REQUESTED_TO_PROVIDER = 'REQUESTED_TO_PROVIDER',
  PAYED = 'PAYED',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  ARCHIVED = 'ARCHIVED',
}
